import { render } from "./DuplicateRulePopup.vue?vue&type=template&id=099bc654&ts=true"
import script from "./DuplicateRulePopup.vue?vue&type=script&lang=ts"
export * from "./DuplicateRulePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__